import { useI18n } from '../../../composables/use-i18n';
import { ref } from 'vue';
import _ from 'lodash';
import { setLastCommentScope, getLastCommentScope } from '../services/last-comment-scope';
import type { CommentScope } from '../services/last-comment-scope';


export function useCommentScope() {
    const { t } = useI18n();

    const data = [{
        label: t('snapBusiness.comment.visibleScope.ORG'),
        tag: t('snapBusiness.comment.tag.ORG'),
        key: 'ORG'
    }, {
        label: t('snapBusiness.comment.visibleScope.SPACE'),
        tag: t('snapBusiness.comment.tag.SPACE'),
        key: 'SPACE'
    }, {
        label: t('snapBusiness.comment.visibleScope.PRIVATE'),
        tag: t('snapBusiness.comment.tag.PRIVATE'),
        key: 'PRIVATE'
    }];

    const supportedScopes = ref<CommentScope[]>([]);

    /**
     * 当前注释的可见范围
     */
    const currentScope = ref<CommentScope>(data[1]);

    function changeCurrentScope(scope: CommentScope) {
        currentScope.value = scope;
        setLastCommentScope(scope);
    }

    function setSupportedScopes(options: CommentScope[]) {
        supportedScopes.value = options;
    }

    function handleScopesWhenCommentChange(options: {
        isPersonal: boolean;
        sourceFrom: 'WORKSPACE' | 'ANALYTICS' | 'EUREKA' | 'VOTE';
    }) {
        let scopes: CommentScope[] = [...data];
        if (options.isPersonal) {
            scopes = scopes.filter(item => item.key !== 'ORG');
            setSupportedScopes(scopes);
        }
        if (options.sourceFrom === 'ANALYTICS' || options.sourceFrom === 'EUREKA') {
            setSupportedScopes(scopes.filter(item => item.key !== 'SPACE'));
        }
        else if (options.sourceFrom === 'VOTE') {
            setSupportedScopes(scopes.filter(item => item.key === 'SPACE'));
        }
        else {
            setSupportedScopes(scopes);
        }
    }

    function handleScopeWhenCommentChange(comment: { visible_scope?: string }) {
        if (!comment.visible_scope) {
            const scope: CommentScope = getLastCommentScope();
            if (scope && _.find(supportedScopes.value, { key: scope.key })) {
                changeCurrentScope(scope);
            } else {
                changeCurrentScope(supportedScopes.value[1] || supportedScopes.value[0]);
            }
        }
        if (comment.visible_scope === 'SPACE') {
            if(!_.find(supportedScopes.value, { key: 'SPACE' })) {
                supportedScopes.value = [...supportedScopes.value, data[1]]
            }
            changeCurrentScope(data[1]);
        } else {
            const scope = supportedScopes.value.find(item => item.key === comment.visible_scope);
            scope && changeCurrentScope(scope);
        }
    }

    return {
        /**\
         * 支持的可见范围
         */
        supportedScopes,
        /**
         * 当前的可见范围
         */
        currentScope,
        /**
         * 改变当前的可见范围
         */
        changeCurrentScope,
        /**
         * 设置可见范围
         * 1. 个人账号不显示组织选项
         * 2. 来自ANALYTICS/EUREKA的不显示工作空间选项
         * 3. 来自VOTE的只显示工作空间选项
         */
        handleScopesWhenCommentChange,
        /**
         * 处理注释变化时的可见范围
         */
        handleScopeWhenCommentChange,
    };
}
